import React, { useState } from 'react'

import ResultsArea from './ResultsArea'
import InputArea from './InputArea'

import 'bootstrap/dist/css/bootstrap.min.css'
import AppNavbar from './AppNavbar'
import { Row, Col, Container, Button, Modal, Form } from 'react-bootstrap'

import generate from 'json2interface'

import './App.css'

function App () {
  const defaultValue = 
`{
  "id": 1,
  "name": "Leanne Graham",
  "username": "Bret",
  "email": "Sincere@april.biz",
  "address": {
    "street": "Kulas Light",
    "suite": "Apt. 556",
    "city": "Gwenborough",
    "zipcode": "92998-3874",
    "geo": {
      "lat": "-37.3159",
      "lng": "81.1496"
    }
  },
  "phone": "1-770-736-8031 x56442",
  "website": "hildegard.org",
  "company": {
    "name": "Romaguera-Crona",
    "catchPhrase": "Multi-layered client-server neural-net",
    "bs": "harness real-time e-markets"
  }
}`

  const [jsonData, setJsonData] = useState(defaultValue)
  const [typeScriptOutput, setTypeScriptOutput] = useState('')
  const [rootObjectName, setRootObjectName] = useState('RootObject')
  const [showModal, setShowModal] = useState(false)

  const handleInputChange = value => {
    setJsonData(value)
  }

  const handleOutputChange = value => {
    setTypeScriptOutput(value)
  }

  const handleClose = () => setShowModal(false)
  const handleShow = () => setShowModal(true)

  const convert = jsonData => {
    try {
      setTypeScriptOutput(generate(jsonData, rootObjectName || 'RootObject'))
    } catch (err) {
      handleShow(true)
    }
  }

  const clear = () => {
    setJsonData('')
    setTypeScriptOutput('')
  }

  return (
    <div>
      <AppNavbar></AppNavbar>
      <Container fluid>
        <Row className='pt-3'>
          <Col lg={5}>
            <InputArea
              value={jsonData}
              handleChange={handleInputChange}
            ></InputArea>
          </Col>
          <Col lg={2} className='align-self-center'>
            <h5 className='form-label'>&nbsp;</h5>
            <Button block className='mt-3' onClick={() => convert(jsonData)}>
              Generate interfaces
            </Button>
            <Button block variant='outline-secondary' onClick={() => clear()}>
              Reset
            </Button>
            <Form className='mt-4'>
              <Form.Group controlId='rootInterfaceName'>
                <Form.Label>Root Object name</Form.Label>
                <Form.Control
                  type='text'
                  value={rootObjectName}
                  onChange={e => setRootObjectName(e.target.value)}
                  placeholder='RootObject'
                />
              </Form.Group>
            </Form>
          </Col>
          <Col lg={5}>
            <ResultsArea
              value={typeScriptOutput}
              handleChange={handleOutputChange}
            ></ResultsArea>
          </Col>
        </Row>
      </Container>

      <Modal show={showModal} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Uh-oh!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          That's not a valid JSON! :)
          <ul>
            <li>Check the JSON validity</li>
            <li>Mind the trailing commas</li>
          </ul>
          If the conversion still fails open me an{' '}
          <a href='https://github.com/michelefenu/json2interface/issues'>
            issue on Github
          </a>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='primary' onClick={handleClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default App
